import FallbackShipping from 'components/pages/checkout/CheckoutView/Payment/Shipping/FallbackShipping';
import Heading from 'components/text/Heading';
import IngridWidget from '@grebban/centra-ingrid-delivery-react';
import PropTypes from 'prop-types';
import React from 'react';
import { above } from 'utils/mediaqueries';
import colors from 'config/theme/colors';
import { injectModel } from 'state';
import styled from 'libs/styled';
import useBasket from 'hooks/useBasket';
import { useSelector } from 'react-redux';
import Events from 'libs/Events';

const ShowOrHide = styled('div')``;

const StyledCheckoutSection = styled('section')`
    border-top: 1px solid ${colors.grey4};
    border-bottom: 1px solid ${colors.grey4};
    padding: 24px 0;

    ${above.md} {
        padding: 32px 0;
    }
`;

const ShippingHandler = ({ showShippingAndPayment = true }) => {
    const basket = useBasket();
    const { shippingMethodId, shippingMethods } = basket;
    const heading = useSelector(state => state.page.data.checkout.shipping.heading);

    // Check if Ingrid is available.
    // If it is, we ALWAYS want to use it.
    let ShippingMethod = FallbackShipping;
    let usedShippingMethod = shippingMethodId;

    if (shippingMethods.ingrid !== undefined && shippingMethods.ingrid.snippet !== null) {
        usedShippingMethod = 'ingrid';
        ShippingMethod = IngridWidget;
    }

    return (
        <StyledCheckoutSection>
            {heading && <Heading type={heading.type}>{heading.text}</Heading>}
            <ShowOrHide display={showShippingAndPayment ? 'block' : 'none'} mt="12px">
                <ShippingMethod
                    data={shippingMethods[usedShippingMethod]}
                    onLoad={() => {
                        Events.trigger('shipping.loaded');
                    }}
                />
            </ShowOrHide>
        </StyledCheckoutSection>
    );
};

ShippingHandler.propTypes = {
    showShippingAndPayment: PropTypes.bool,
};

export default injectModel('basket')(ShippingHandler);
